import { render, staticRenderFns } from "./cardinal.vue?vue&type=template&id=42aebaca"
import script from "./cardinal.vue?vue&type=script&lang=js"
export * from "./cardinal.vue?vue&type=script&lang=js"
import style0 from "./cardinal.vue?vue&type=style&index=0&id=42aebaca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports